import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-qb-file',
  templateUrl: './summary-qb-file.component.html',
  styleUrls: ['./summary-qb-file.component.scss']
})
export class SummaryQbFileComponent {

  constructor() { }
}
